export default () => ({
  componentName: 'cell-place',
});
